import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { type AudienceSegmentTagGroupOperator, audienceSegmentTagGroupOperator } from '../../constants.ts';

type LogicalSeparatorProps = {
  variant: AudienceSegmentTagGroupOperator;
};

export const LogicalSeparator = ({ variant }: LogicalSeparatorProps) => (
  <Stack
    sx={{
      border: '1px solid',
      borderColor: theme =>
        variant === audienceSegmentTagGroupOperator.OR ? theme.palette.success.main : theme.palette.primary.main,
      backgroundColor: theme =>
        variant === audienceSegmentTagGroupOperator.OR ? theme.palette.success.light : theme.palette.primary.light,
      px: 1.5,
      borderRadius: '50px',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Typography
      variant="body1"
      sx={{
        fontWeight: '600',
        fontSize: '12px',
        color: theme =>
          variant === audienceSegmentTagGroupOperator.OR ? theme.palette.success.main : theme.palette.primary.main,
      }}
    >
      {variant}
    </Typography>
  </Stack>
);
